import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import useAntTable from "../../../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import Upload from "../../../../components/Upload";
import * as api from "../../../../apis/platforms/dealer/product";
import {
    Card,
    Form,
    InputNumber,
    Select as AntSelect,
    Input,
    Switch,
    message,
    Button,
    Modal, Row, Col
} from "antd";
import Divider from "../../../../components/Divider";
import CategoryMultipleLevelSelect from "../../../../components/CategoryMultipleLevelSelect";
import styles from "./index.module.css";
import Select from "../../../../components/Select";
import {useSelector} from "react-redux";
import {RootState} from "../../../../models";
import {useRequest} from "ahooks";
import {useEffect, useState} from "react";
import {useWatch} from "antd/lib/form/Form";
import ProductDetailModal from "./ProductDetailModal";
import * as cartApi from "../../../../apis/platforms/dealer/cart";
import useAuth from "../../../../utils/useAuth";
import UploadModal from "../../../../components/UploadModal";
import withAuth from "../../../../utils/withAuth";


function inventoryDescription(v: number) {
    if (v <= 0) {
        return '无货';
    } else if (v <= 50) {
        return '紧张';
    } else if (v <= 500) {
        return '充足';
    } else {
        return '非常充足';
    }
}

const ImportProductButton = withAuth('importProductToCart', Button);

function Product(props: React.ComponentProps<any>) {

    const showPrice = useAuth().indexOf('showPrice') > -1;
    const [suits, setSuits] = useState<Array<any>>([]);
    const [productQtys, setProductQtys] = useState<any>({});
    const [products, setProducts] = useState([]);
    const [productRecord, setProductRecord] = useState<any | null>(null);
    const [importExcelModalVisible, setImportExcelModalVisible] = useState(false);
    const {tableProps, form, search} = useAntTable(api.getDealerProducts, {
        selectTable: true, onSuccess(data) {
            const result = (data.list || []).map((i: any) => {
                i.rowKey = Math.random().toString(16).substring(2) + Date.now().valueOf();
                return {...i};
            });
            setProducts(result);
        }
    });

    const inContract = Form.useWatch("inContract", form);


    const {loading: loadingImport, run: runImport} = useRequest(api.importProductToCart, {
        manual: true,
        onSuccess(res){
            message.success('上传成功');
            setImportExcelModalVisible(false);
        }
    })

    const changeCategoryToGreat = (product: any) => {
        const parents = (product.categoryParents || '').replace('//', '').split('/');
        const greatCategory = parents[0] || product.categoryId;
        const newProduct = {...product};
        newProduct.categoryId = greatCategory ? greatCategory : null;
        return newProduct;
    }
    const doSubmit = async (params: any) => {

        switch (params.type) {
            case 'suit':
                const records = products.map((p: any) => ({...p, qty: p.qty * form.getFieldValue('qty')}));
                await cartApi.addToCartProducts(records.map(changeCategoryToGreat));
                break;
            case 'products':
                params.record.forEach((r: any) => r.qty = productQtys[r.rowKey]);
                await cartApi.addToCartProducts(params.record.map(changeCategoryToGreat));
                break;
            case 'contract-product':
                params.record.qty = productQtys[params.record.rowKey];
                params.record.productId = params.record.id;
                await cartApi.addToCartProducts([params.record].map(changeCategoryToGreat))
                break;
            default:
                break;
        }
        tableProps?.rowSelection?.onChange([], []);
        message.success('已添加购物车');
    }


    const {loading: loadingSuit, runAsync: getSuitDict} = useRequest(api.getSuitDict, {
        manual: true,
        defaultParams: [form.getFieldsValue()],
        onSuccess(res) {
            const result = res?.data?.data || [];
            setSuits(result);
            if (!result?.length) {
                form.setFieldValue('suitId', null);
            }
        }
    });

    const {loading: loadingAddToCart, runAsync: runAddToCart} = useRequest(doSubmit, {
        manual: true,
        onSuccess(res) {
            message.success('添加成功');
        }
    });

    const curHospitalId = useWatch('hospitalId', form);
    const curInContract = useWatch('inContract', form);
    const curSuitId = useWatch('suitId', form);


    useEffect(() => {
        form.setFieldValue('qty', 0);
    }, [curSuitId]);

    useEffect(() => {
        Modal.warning({
            title: '提示',
            content: '如果要订试剂，请先选择终端医院。',
            afterClose: () => {
                handleFilterChange();
            }
        });
    }, []);

    const columns: StandardColumnsType = [
        {
            dataIndex: 'image',
            key: 'image',
            title: '图片',
            render: value => (value && <Upload value={value} maxCount={1} listType={'picture-card'} disabled/>)
        },
        {
            dataIndex: 'suitName',
            key: 'suitName',
            title: '套餐名称',
            width: 100
        },
        {
            dataIndex: 'code',
            key: 'code',
            title: '商品编码',
            width: 100
        },
        {
            dataIndex: 'name',
            key: 'name',
            title: '商品名称',
            width: 100
        },
        {
            dataIndex: 'specification',
            key: 'specification',
            title: '规格型号',
            width: 100
        },
        {
            dataIndex: 'abbreviation',
            key: 'abbreviation',
            title: '英文缩写',
            width: 80
        },
        {
            dataIndex: 'unit',
            key: 'unit',
            title: '单位',
            width: 60
        },
        {
            dataIndex: 'method',
            key: 'method',
            title: '方法',
            width: 100
        },
        {
            dataIndex: 'useIn',
            key: 'useIn',
            title: '适用机型',
            width: 100
        },
        {
            dataIndex: 'contractCode',
            key: 'contractCode',
            title: '合同',
            width: 100
        },
        ...showPrice ? [
            {
                dataIndex: 'price',
                key: 'price',
                title: '销售价',
                width: 100
            },
        ] : [],
        {
            dataIndex: 'inventoryQty',
            key: 'inventoryQty',
            title: '库存',
            width: 80,
            render(v, r: any) {
                return inventoryDescription(v);
            }
        },
        {
            dataIndex: 'restrictQty',
            key: 'restrictQty',
            title: '限购数量',
            width: 100
        },
        {
            dataIndex: 'remainQty',
            key: 'remainQty',
            title: '限购剩余数量',
            width: 100,
            render(v: any) {
                return Number.isInteger(v) && v < 0 ? 0 : v
            }
        },
        {
            dataIndex: 'qty',
            key: 'qty',
            title: '数量',
            fixed: "right",
            width: 120,
            render(value, record: any) {
                return <InputNumber min={0} step={1} defaultValue={value}
                                    onChange={(v) => handleProductQtyChange(record, v)}
                                    disabled={!!curSuitId}/>
            }
        },
        {
            dataIndex: 'operation',
            title: '操作',
            fixed: "right",
            width: 140,
            render(_, record: any) {
                return <Divider>
                    <a onClick={() => setProductRecord(record)}>详情</a>
                    {(!curSuitId && record.contractId) ?
                        <a onClick={() => doSubmit({type: 'contract-product', record})}>加入购物车</a> : null}
                </Divider>
            }
        }
    ];

    const handleFilterChange = () => {
        // console.log(curHospitalId, '  ', curInContract);
        tableProps?.rowSelection?.onChange([], []);
        const values = form.getFieldsValue();
        //医院从无到有,自动开启合同商品选项
        if (!!values.hospitalId && !curHospitalId) {
            values.inContract = true;
            form.setFieldValue('inContract', true);
        }
        //关闭合同商品的选项，自动置空医院
        if (!values.inContract && !!curInContract) {
            values.hospitalId = undefined;
            form.setFieldValue('hospitalId', undefined);
        }
        getSuitDict(values).then(search.submit);
        // search.submit();
    }

    const handleProductQtyChange = (record: any, value?: number) => {
        const newQtys = {...productQtys};
        newQtys[record.rowKey] = value;
        setProductQtys(newQtys);
    }

    const handleImport = async (file:File) =>{
        const values = form.getFieldsValue();
        //获取筛选情况
        const {hospitalId} = values;
        return runImport( hospitalId, file);
    }

    // const record2RowKey = (record: any) => {
    //     return `${record.contractId}-${record.suitId}-${record.productId}`;
    // }

    const toolbar = (
        <Row style={{width: '100%'}} className={styles.Toolbar}>
            {!!curSuitId && (
                <>
                    <Form.Item name={'qty'} label={'数量'}>
                        <InputNumber step={1} defaultValue={0}/>
                    </Form.Item>
                    <Button type={"primary"} disabled={!form.getFieldValue('inContract') || !products?.length}
                            style={{marginRight: 8}}
                            onClick={() => doSubmit({
                                type: 'suit',
                                record: {suitId: curSuitId, qty: form.getFieldValue('qty')}
                            })}>套餐加入购物车</Button>
                </>
            )}
            <Form.Item name={'suitId'} label={'套餐'} style={{flex: 1}}>
                <AntSelect options={suits} fieldNames={{value: 'id', label: 'name'}} placeholder={'请选择套餐'}
                           allowClear
                           showSearch
                           optionFilterProp={'options'}
                           filterOption={(input, option) => option?.name?.includes(input)}
                           onChange={() => handleFilterChange()}/>
            </Form.Item>
        </Row>
    );

    return <PageHeaderLayout
        withFooterBar={tableProps?.rowSelection?.selectedRows?.length > 0 && !!tableProps?.rowSelection?.selectedRows?.every((r: any) => !!r.contractId)}
        okBtnText={'添加到购物车'} onCancel={() => tableProps?.rowSelection?.onChange([], [])}
        onOk={() => doSubmit({type: 'products', record: tableProps?.rowSelection?.selectedRows})}>
        <Card>
            <Form form={form}>
                <Form.Item name={'categoryId'}>
                    <CategoryMultipleLevelSelect onChange={() => handleFilterChange()}/>
                </Form.Item>
                <Form.Item name={'hospitalId'} label={'终端医院'} className={styles.RedLabel}>
                    <Select url={api.getHospitalInContract}
                            allowClear
                            getData={data => data.data}
                            valueField={'id'}
                            textField={'hospitalInstrumentsFullName'}
                            placeholder={'请选择参与合同的终端医院'}
                            onChange={() => handleFilterChange()}/>
                </Form.Item>
                <Row>
                    <Col span={8}>
                        <Form.Item name={'code'}>
                            <Input placeholder={'请输入商品名称/编码'}
                                   allowClear
                                   onKeyPress={(e) => e.which === 13 && handleFilterChange()}
                                   onBlur={() => handleFilterChange()}/>
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item name={'inContract'} label={'已签合同商品'} valuePropName={'checked'}
                                   initialValue={true}>
                            <Switch onChange={() => handleFilterChange()}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <ImportProductButton type={"primary"} onClick={()=> setImportExcelModalVisible(true)} disabled={!inContract}>导入商品添加到购物车</ImportProductButton>
                    </Col>
                </Row>

                <StandardTable {...tableProps} rowSelection={!curSuitId ? tableProps.rowSelection : undefined}
                               columns={columns} form={form} search={search} toolbar={toolbar} rowKey={'rowKey'}
                               scroll={{x: 'max-content'}}
                               showCard={false}/>
            </Form>
        </Card>
        <ProductDetailModal record={productRecord} onCancel={() => setProductRecord(null)}/>
        <UploadModal title={'导入商品添加到购物车'} key={'upload'} onUpload={handleImport} open={importExcelModalVisible}
                     template={'/template/购物车商品导入模板.xlsx'} confirmLoading={loadingImport}
                     onCancel={() => setImportExcelModalVisible(false)}/>
    </PageHeaderLayout>
}

export default Product;
